import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const LoadingButton = ({ isLoading, onClick, children, ...props }) => {
    return (
        <Button onClick={onClick} disabled={isLoading} {...props}>
            {isLoading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span className="sr-only">Loading...</span>
                </>
            ) : (
                children
            )}
        </Button>
    );
};

export default LoadingButton;